(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/extends', 'babel-runtime/helpers/objectWithoutProperties', 'react', '@material-ui/core', './SplitButton/SplitButton', '../LoadingIndicators/index', './Buttons.css'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/extends'), require('babel-runtime/helpers/objectWithoutProperties'), require('react'), require('@material-ui/core'), require('./SplitButton/SplitButton'), require('../LoadingIndicators/index'), require('./Buttons.css'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.objectWithoutProperties, global.react, global.core, global.SplitButton, global.index, global.Buttons);
    global.Buttons = mod.exports;
  }
})(this, function (exports, _extends2, _objectWithoutProperties2, _react, _core, _SplitButton, _index, _Buttons) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.SplitButton = exports.ButtonFlatSmall = exports.ButtonFlatLarge = exports.ButtonSecondarySmall = exports.ButtonSecondaryLarge = exports.ButtonPrimarySmall = exports.ButtonPrimaryLarge = exports.Button = undefined;

  var _extends3 = _interopRequireDefault(_extends2);

  var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

  var _react2 = _interopRequireDefault(_react);

  var _SplitButton2 = _interopRequireDefault(_SplitButton);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Button = function Button(_ref) {
    var children = _ref.children,
        classes = _ref.classes,
        isLoading = _ref.isLoading,
        rest = (0, _objectWithoutProperties3.default)(_ref, ['children', 'classes', 'isLoading']);
    return _react2.default.createElement(
      _core.Button,
      (0, _extends3.default)({
        classes: {
          root: classes.root,
          label: isLoading ? classes.labelWhileLoading : ''
        }
      }, rest),
      isLoading && _react2.default.createElement(
        'div',
        { className: classes.spinnerContainer },
        _react2.default.createElement(_index.Spinner, { className: classes.spinner })
      ),
      children
    );
  };

  exports.Button = Button;
  var ButtonPrimaryLarge = exports.ButtonPrimaryLarge = (0, _core.withStyles)(_Buttons.buttonPrimaryLargeStyles)(Button);
  var ButtonPrimarySmall = exports.ButtonPrimarySmall = (0, _core.withStyles)(_Buttons.buttonPrimarySmallStyles)(Button);
  var ButtonSecondaryLarge = exports.ButtonSecondaryLarge = (0, _core.withStyles)(_Buttons.buttonSecondaryLargeStyles)(Button);
  var ButtonSecondarySmall = exports.ButtonSecondarySmall = (0, _core.withStyles)(_Buttons.buttonSecondarySmallStyles, { name: 'pj-comp-styles' })(Button);
  var ButtonFlatLarge = exports.ButtonFlatLarge = (0, _core.withStyles)(_Buttons.buttonFlatLargeStyles)(Button);
  var ButtonFlatSmall = exports.ButtonFlatSmall = (0, _core.withStyles)(_Buttons.buttonFlatSmallStyles)(Button);
  var SplitButton = exports.SplitButton = _SplitButton2.default;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Buttons/Buttons.js
// module id = 855
// module chunks = 1